import penIcon from '../../../../assets/icons/png/3x/pen-regular-red@3x.png';
import { ICONSIZE } from '../../../../components/Icon';
import SelectableIcon from '../../../../../presentation/components/SelectableIcon';
import React from 'react';

interface EditIconProps {
  alt: string;
  onClick: (event: React.MouseEvent) => void;
  onKeyDown: (event: React.KeyboardEvent) => void;
}

const EditIcon: React.FC<EditIconProps> = ({ alt, onClick, onKeyDown }) => {
  return (
    <SelectableIcon
      alt={alt}
      iconSrc={penIcon}
      size={ICONSIZE.small}
      onClick={onClick}
      onKeyDown={onKeyDown}
    />
  );
};

export default EditIcon;
